<template>
  <b-modal v-model="localShowDetailModal" centered title="Confirmation Completion" @hide="$emit('close')" hide-header-close>
    <div v-if="data" class="d-flex flex-column gap-3">
      <span>Apakah Anda yakin ingin menyelesaikan pelatihan ini?</span>
      <ul>
        <li>
          {{ data?.training?.title || data?.id }}
        </li>
      </ul>
    </div>

    <template #modal-footer>
      <div class="d-flex justify-content-end align-items-center w-100">
        <b-button variant="primary" :disabled="isSubmitting" @click="handleSubmit"> Complete </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { titleCase } from "@/utils/titleCase";

export default {
  name: "ConfirmationSubmitModal",
  props: {
    showConfirmationSubmit: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: null,
    },
    isSubmitting: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    localShowDetailModal: {
      get() {
        return this.showConfirmationSubmit;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },
  methods: {
    titleCase,
    handleSubmit() {
      const id = this.data.id;

      this.$emit("submit", id);
    },
  },
};
</script>

<style scoped>
.gap-2 > * + * {
  margin-left: 0.5rem;
}

.table td {
  padding: 0.5rem 0;
}

.d-flex.flex-wrap {
  row-gap: 0.25rem;
  column-gap: 0.25rem;
}

.completion-badge {
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
}
</style>
